import { contentPageAtlasRedirect, type PublicRouteState } from './publicRoute'
import type { AnalyticsPageType } from './analytics'

export function analyticsPageTypeForRoute(route: PublicRouteState | null): AnalyticsPageType {
  if (route?.pageType === 'atlas' || route?.pageType === 'embed') return 'atlas'
  if (route?.semanticKind === 'municipality_profile') return 'municipality_profile'
  if (route?.semanticKind === 'municipality_indicator') return 'municipality_indicator'
  return 'content'
}

export type DocumentAnalyticsStartup =
  | { action: 'redirect'; redirect: string }
  | { action: 'initialize'; pageType: AnalyticsPageType; trackPageViewImmediately: boolean }

/**
 * Resolve legacy semantic-query redirects before any analytics vendor can be
 * injected. This makes the privacy/attribution ordering explicit and testable.
 */
export function documentAnalyticsStartup(
  route: PublicRouteState | null,
  location: Pick<Location, 'search' | 'hash'>,
  hasApplicationMount: boolean,
): DocumentAnalyticsStartup {
  const redirect = contentPageAtlasRedirect(route, location)
  if (redirect) return { action: 'redirect', redirect }
  return {
    action: 'initialize',
    pageType: analyticsPageTypeForRoute(route),
    trackPageViewImmediately: !hasApplicationMount,
  }
}
